import { Injectable } from '@angular/core';
import { Breadcrumb } from '@nuso/common/ui-components';
import { BehaviorSubject } from 'rxjs';

const IAM_BREADCRUMB_NAME = 'IAM';

@Injectable({
  providedIn: 'root'
})
export class IamBreadcrumbsService {
  private _breadcrumbs$ = new BehaviorSubject<Breadcrumb[]>([{ name: IAM_BREADCRUMB_NAME }]);
  breadcrumbs$ = this._breadcrumbs$.asObservable();

  setRootPage(rootPageName: string) {
    this._breadcrumbs$.next([
      { name: IAM_BREADCRUMB_NAME, link: '.' },
      { name: rootPageName }
    ]);
  }

  setDetailsPage(rootPagePath: string, rootPageName: string, detailsPageName: string) {
    this._breadcrumbs$.next([
      { name: IAM_BREADCRUMB_NAME, link: '.'},
      { name: rootPageName, link: rootPagePath },
      { name: detailsPageName }
    ]);
  }
}
